import ViewMaintenanceItem from "../common/view-maintenance-item";

export default function ViewOwnerLogbookMaintenanceItem() {
  return <ViewMaintenanceItem />;
}
